// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__1jSJo","content":"Consent_content__2nlff","footer":"Consent_footer__13Z8I"};